import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-logo">
        <Link to="/">EarnGain</Link>
      </div>
      <nav className="header-nav">
        <Link to="/login">Login</Link>
        <Link to="/register">Sign Up</Link>
      </nav>
    </header>
  );
};

export default Header;